import Vue from "vue";

Vue.directive("visible-on-screen", {
  bind: function (el) {
    const options = {
      root: null,
      // Add rootMargin buffer to improve detection reliability
      rootMargin: "50px",
      // Lower threshold to 0.9 for better Safari compatibility
      // Safari has known issues with threshold: 1.0 (100% visibility requirement)
      threshold: 0.9,
    };

    const observer = new IntersectionObserver(([entry]) => {
      el.dispatchEvent(
        new CustomEvent("visible", { detail: entry.isIntersecting }),
      );
    }, options);

    observer.observe(el);

    el._vueIntersectionObserver = observer;

    // Immediate check for already-visible elements (Safari fix)
    // Use requestAnimationFrame to ensure DOM is fully rendered
    requestAnimationFrame(() => {
      const rect = el.getBoundingClientRect();
      const viewportHeight =
        window.innerHeight || document.documentElement.clientHeight;
      const isVisible = rect.top >= -50 && rect.bottom <= viewportHeight + 50;

      if (isVisible) {
        el.dispatchEvent(new CustomEvent("visible", { detail: true }));
      }
    });
  },
  unbind: function (el) {
    if (el._vueIntersectionObserver) {
      el._vueIntersectionObserver.disconnect();
      delete el._vueIntersectionObserver;
    }
  },
});
